/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import { PageMeta, PageMetaService } from '@lm-nx-frontend/lm-inf-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SchemaBuilder } from '../schema.interface';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbSchemaBuilder implements SchemaBuilder {
  constructor(protected pageMetaService: PageMetaService) {}

  build(): Observable<any> {
    return this.pageMetaService
      .getMeta()
      .pipe(map((pageMeta: PageMeta | null) => this.collect(pageMeta)));
  }

  protected collect(pageMeta: PageMeta | null): any {
    if (!pageMeta?.breadcrumbs) {
      return;
    }
    const crumbs = pageMeta.breadcrumbs.map((crumb, index) => {
      return {
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@id': crumb.link,
          name: crumb.label,
        },
      };
    });

    if (pageMeta.title) {
      crumbs.push({
        '@type': 'ListItem',
        position: crumbs.length + 1,
        item: {
          '@id': pageMeta.title,
          name: pageMeta.title,
        },
      });
    }

    return {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: crumbs,
    };
  }
}
